import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Results from './Results';
import '../styles/WordOfTheDay.css';
import monsterIcon from '../assets/monster-icon.png';
import errorImage from '../assets/error-image.png';
import movingGif from '../assets/moving-gif.gif';

export default function WordOfTheDay({ setScore }) {
    const [words, setWords] = useState([]);
    const [details, setDetails] = useState([]);
    const [selectedWord, setSelectedWord] = useState(null);
    const [dataFetched, setDataFetched] = useState(false);
    const [apiError, setApiError] = useState(false);
    const [showGif, setShowGif] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchWordsOfTheDay = useCallback(async () => {
        try {
            const response = await axios.get('https://random-word-api.herokuapp.com/word?number=2');
            const randomWords = response.data;
            const detailsResponses = await Promise.all(
                randomWords.map(word => axios.get(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`))
            );
            setWords(randomWords);
            setDetails(detailsResponses.map(res => res.data[0]));
            setDataFetched(true);
            setApiError(false);
        } catch (error) {
            console.error("Error fetching the words of the day or their details", error);
            setApiError(true);
            setDataFetched(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchWordsOfTheDay();
    }, [fetchWordsOfTheDay]);

    const handleWordClick = (index) => {
        setSelectedWord(index);
        setScore(prevScore => prevScore + 1);
    };

    const handleBackButtonClick = () => {
        setSelectedWord(null);
        fetchWordsOfTheDay();
    };

    const handleImageClick = () => {
        setShowGif(!showGif);
    };

    return (
        <div className="WordOfTheDay">
            {loading ? (
                <p>Loading...</p>
            ) : apiError ? (
                <div className="error-container">
                    {showGif ? (
                        <img
                            src={movingGif}
                            alt="Moving GIF"
                            className="moving-gif"
                            onClick={handleImageClick}
                            style={{ cursor: 'pointer' }}
                        />
                    ) : (
                        <img
                            src={errorImage}
                            alt="Error"
                            className="error-image"
                            onClick={handleImageClick}
                            style={{ cursor: 'pointer' }}
                        />
                    )}
                </div>
            ) : (
                dataFetched && (
                    <>
                        <h3>Words of the Day</h3>
                        {selectedWord !== null && (
                            <button className="back-button" onClick={handleBackButtonClick}>Back</button>
                        )}
                        <div className="word-cards-container">
                            {words.map((word, index) => (
                                <React.Fragment key={index}>
                                    {selectedWord === null || selectedWord === index ? (
                                        <div
                                            className={`word-card player${index + 1}-card ${selectedWord === index ? 'selected' : ''}`}
                                            onClick={() => handleWordClick(index)}
                                        >
                                            <img src={monsterIcon} alt="Monster Icon" className="monster-icon" />
                                            <p>Player {index + 1}</p>
                                            <p className="brief-word">{word}</p>
                                            {selectedWord === index && details[index] && <Results results={details[index]} />}
                                        </div>
                                    ) : null}
                                    {selectedWord === null && index === 0 && <div className="x-divider">X</div>}
                                </React.Fragment>
                            ))}
                        </div>
                    </>
                )
            )}
        </div>
    );
}
